import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { SiteLayout } from './components/layout/SiteLayout';
import { HomePage } from './pages/HomePage';

const ServicePage = lazy(() => import('./pages/ServicePage').then((module) => ({ default: module.ServicePage })));
const WorkPage = lazy(() => import('./pages/WorkPage').then((module) => ({ default: module.WorkPage })));
const WorkDetailPage = lazy(() => import('./pages/WorkDetailPage').then((module) => ({ default: module.WorkDetailPage })));
const ProcessPage = lazy(() => import('./pages/ProcessPage').then((module) => ({ default: module.ProcessPage })));
const AboutPage = lazy(() => import('./pages/AboutPage').then((module) => ({ default: module.AboutPage })));
const ContactPage = lazy(() => import('./pages/ContactPage').then((module) => ({ default: module.ContactPage })));
const LegacyConceptRedirect = lazy(() => import('./pages/LegacyConceptRedirect').then((module) => ({ default: module.LegacyConceptRedirect })));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage').then((module) => ({ default: module.PrivacyPage })));
const TermsPage = lazy(() => import('./pages/TermsPage').then((module) => ({ default: module.TermsPage })));
const WhiteLabelPage = lazy(() => import('./pages/WhiteLabelPage').then((module) => ({ default: module.WhiteLabelPage })));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then((module) => ({ default: module.NotFoundPage })));

export default function App() {
  return (
    <Suspense fallback={<div className="route-loading">Loading…</div>}>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="services/:slug" element={<ServicePage />} />
          <Route path="work" element={<WorkPage />} />
          <Route path="work/:slug" element={<WorkDetailPage />} />
          <Route path="process" element={<ProcessPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="concepts" element={<LegacyConceptRedirect />} />
          <Route path="concepts/:slug" element={<LegacyConceptRedirect />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="white-label" element={<WhiteLabelPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
